export const MARKETING_ACTION_FEEDBACK_BANNER_COMPONENTS_NAMESPACE =
    "marketing-action-feedback-banner-components";
export const MARKETING_ACTION_FEEDBACK_BANNER_TK = "MARKETING_ACTION_FEEDBACK_BANNER_TK";
